export const getApiBaseUrl = () =>
  import.meta.env.VITE_APP_API_BASE_URL ?? '/api';
